var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Record.module.scss';
var RecordNote = function (_a) {
    var record = _a.record;
    return (_jsxs("div", { children: [_jsx("div", { children: _jsx("p", { children: "rate lama (100k / sesi) - 2 sesi COFFEE " }) }), _jsxs("div", __assign({ className: styles['record-cp__section'] }, { children: [_jsx("p", __assign({ className: styles['title'] }, { children: "Jadwal Note:" })), _jsx("p", { children: "Private Acc" })] }))] }));
};
export default RecordNote;
